export default "__VITE_ASSET__B0nEj9se__"